import { http } from '../../../api/http';
import type {
  PisoResponse,
  MesaResponse,
  TransferirMesaRequest,
  SepararCuentaRequest,
  OrdenPosResponse,
} from '../types/pos.types';

export class PosMesaService {
  private static readonly ENDPOINTS = {
    PISOS: '/pos/mesa/pisos',
    MESA: '/pos/mesa',
  };

  public static async getPisos(idSucursal: number): Promise<PisoResponse[]> {
    try {
      const response = await http.get(this.ENDPOINTS.PISOS, { params: { idSucursal } });
      return response.data;
    } catch (error) {
      console.error('Error al obtener pisos:', error);
      throw error;
    }
  }

  public static async cambiarEstado(idMesa: number, estado: string): Promise<MesaResponse> {
    try {
      const response = await http.put(`${this.ENDPOINTS.MESA}/${idMesa}/estado`, JSON.stringify(estado), {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      console.error('Error al cambiar estado:', error);
      throw error;
    }
  }

  public static async asignarMozo(idMesa: number, idMozo: number): Promise<MesaResponse> {
    try {
      const response = await http.put(`${this.ENDPOINTS.MESA}/${idMesa}/asignar-mozo`, idMozo);
      return response.data;
    } catch (error) {
      console.error('Error al asignar mozo:', error);
      throw error;
    }
  }

  public static async transferirMesa(idMesa: number, data: TransferirMesaRequest): Promise<OrdenPosResponse> {
    try {
      const response = await http.post(`${this.ENDPOINTS.MESA}/${idMesa}/transferir`, data);
      return response.data;
    } catch (error) {
      console.error('Error al transferir mesa:', error);
      throw error;
    }
  }

  public static async separarCuenta(idMesa: number, data: SepararCuentaRequest): Promise<OrdenPosResponse> {
    try {
      const response = await http.post(`${this.ENDPOINTS.MESA}/${idMesa}/separar`, data);
      return response.data;
    } catch (error) {
      console.error('Error al separar cuenta:', error);
      throw error;
    }
  }
}
